import { Icon } from "@iconify/react";
import { Radio } from "../common";

const PaymentMethodRadioGroup = ({ items, activedIndex, onSelect }) => {
  return (
    <div className="grid grid-cols-2 gap-3">
      {items.map((item, index) => (
        <Radio
          key={index}
          actived={activedIndex === index}
          className="py-2.5 rounded-[14px]"
          onClick={() => onSelect(index)}
        >
          <div className="flex flex-col items-center justify-center gap-[17px]">
            {!item.icon ? (
              <span className="text-2xl">💵</span>
            ) : (
              <Icon
                icon={item.icon}
                className={`w-6 h-6 ${
                  activedIndex === index ? "text-primary" : "text-dark-blue"
                }`}
              />
            )}

            <span className="text-sm font-bold">{item.name}</span>
          </div>
        </Radio>
      ))}
    </div>
  );
};

export default PaymentMethodRadioGroup;
